var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 20.8682C39.5 31.5744 30.7722 40.2582 20 40.2582C9.22784 40.2582 0.5 31.5744 0.5 20.8682C0.5 10.162 9.22784 1.47827 20 1.47827C30.7722 1.47827 39.5 10.162 39.5 20.8682Z",
    fill: "white",
    stroke: "#484848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 30.3706L27.0574 15.4256",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0596 25.6968V15.4254H16.7109",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrow);
export default __webpack_public_path__ + "static/media/circle-arrow.07dae3c313fcaea656361de02603bf68.svg";
export { ForwardRef as ReactComponent };